import { render, staticRenderFns } from "./Create-Asset-Stock.vue?vue&type=template&id=ac5f0258&"
import script from "./Create-Asset-Stock.vue?vue&type=script&lang=js&"
export * from "./Create-Asset-Stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports